<template>
  <div class="piloting-selection">
    <p class="h3 mb-2 pt-2 pb-4">Voulez-vous ajouter l’option de pilotage à distance ?</p>

    <div class="row two-parts">
      <div class="col-lg-7 pr-md-5">

      	<!-- Si c'est thermostat sans fils -->
      	 <div v-if="state.radiator.thermostat=='Sans fil'">
	      	<img src="../assets/img/pilotage/illustration-sans-fil-01.png" class="w-100">
	      	<p class="lead"><strong>Système pour thermostat sans fil</strong></p>
	        <p>Connectée à votre box internet, cette passerelle vous permet de piloter vos radiateurs pour chaque pièce.</p>
	        <p>Connecté à des détecteurs d’ouverture de fenêtre (en option), le système se régule automatiquement et vous permet d’économiser en énergie.</p>
	        <p><strong>Totalement évolutif</strong>, ce système vous permet également de connecter d’autres équipements électriques de la maison.</p>
	        <ul class="list-unstyled d-flex mt-4 mb-0 icon-list">
	        	<li class='text-secondary'>
	        		<img src="../assets/img/pilotage/icon/alarme.svg">
	        		<p>Alarme</p>
	        	</li>
	        	<li class='text-secondary'>
	        		<img src="../assets/img/pilotage/icon/video-surveillance.svg">
	        		<p>Vidéo surveillance</p>
	        	</li>
	        	<li class='text-secondary'>
	        		<img src="../assets/img/pilotage/icon/eclairage.svg">
	        		<p>Éclairage</p>
	        	</li>
	        	<li class='text-secondary'>
	        		<img src="../assets/img/pilotage/icon/volets-roulants.svg">
	        		<p>Volets roulants</p>
	        	</li>
	        	<li class='text-secondary'>
	        		<img src="../assets/img/pilotage/icon/portails.svg">
	        		<p>Portails</p>
	        	</li>
	        </ul>
        </div>

        <!-- Si c'est thermostat intégré -->
        <div v-else>
	      	<img src="../assets/img/pilotage/illustration-integre-01.jpg" class="w-100">
	      	<p class="lead"><strong>Système pour thermostat intégré.</strong></p>
	        <p>Grâce à la passerelle Solaris connectée à votre box internet, vous pouvez définir la température de chaque radiateur depuis votre smartphone, d’où vous voulez. Choisissez les plages horaires de fonctionnement sur une interface intuitive, et optimisez vos coûts en énergie.</p>
        </div>

      </div>
      <div class="col-lg-5 px-md-4 pt-4">

        <div class="form-check check-base mb-4 pl-0" @click="setData('piloting',true)">
          <input class="form-check-input d-none" type="radio" name="step-1" id="exampleRadios1" value="option1" :checked="state.piloting">
          <label class="form-check-label" for="exampleRadios1">
          		<div class="radio-check"><i class="far fa-check"></i></div>
             	<p class="mb-0 lead pt-1">Avec le pilotage à distance</p>
          </label>
        </div>
        <div class="form-check check-base mb-4 pl-0" @click="setData('piloting',false)">
          <input class="form-check-input d-none" type="radio" name="step-1" id="exampleRadios2" value="option2" :checked="!state.piloting">
          <label class="form-check-label" for="exampleRadios2">
          		<div class="radio-check"><i class="far fa-check"></i></div>
             	<p class="mb-0 lead pt-1">Sans le pilotage à distance</p>
          </label>
        </div>

        <button class="btn mt-4 btn-md btn-primary rounded-pill" @click="setData('resume',true);setData('resumeLast',true);">
          Finaliser
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PilotingSelection",
  methods:{
  }
}
</script>

<style scoped>

</style>